import { useState } from 'react';
import { BookOpenIcon, ChevronDownIcon, KeyRoundIcon, MapIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
type Pathway = {
  name: string;
  modules: string[];
  used: number;
  total: number;
};
type SkillModule = {
  name: string;
  used: number;
  total: number;
};
const pathways: Pathway[] = [{
  name: 'Digital Marketing',
  modules: ['SEO Foundations', 'Campaign Strategy', 'Analytics Essentials', 'Content Planning'],
  used: 4,
  total: 20
}, {
  name: 'AWS Solutions Architect',
  modules: ['AWS Core Services', 'Cloud Networking', 'Security & IAM', 'High Availability Architecture'],
  used: 8,
  total: 20
}];
const skillModules: SkillModule[] = [{
  name: 'Scrum Master Fundamentals Course',
  used: 20,
  total: 20
}, {
  name: 'IT Bundle',
  used: 75,
  total: 100
}, {
  name: 'Anatomy, Physiology and Coding I Course',
  used: 5,
  total: 20
}, {
  name: 'Human Resources Bundle',
  used: 80,
  total: 100
}];
export function SkillsOverview() {
  const [expandedPathway, setExpandedPathway] = useState('');
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.05
  }} data-phoebe-tour="skills-overview" aria-labelledby="skills-overview-title" className="mt-8 overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm" data-id="element-1603" data-mp="3vyzea8dp40ci">
      <header className="flex flex-col gap-4 border-b border-gray-100 px-5 py-5 sm:px-6 md:flex-row md:items-center md:justify-between" data-id="element-1604" data-mp="nicwh836crkp">
        <div className="flex items-start gap-3" data-id="element-1605" data-mp="ii8f7fufzstf">
          <span className="flex h-9 w-9 flex-none items-center justify-center rounded-lg bg-[#30718D]/10 text-[#30718D]" data-id="element-1606" data-mp="ehy9836nh2ek">
            <KeyRoundIcon size={19} aria-hidden="true" data-id="element-1607" data-mp="9j4wicz6tffg" />
          </span>
          <div data-id="element-1608" data-mp="2z98im5to4754">
            <h2 id="skills-overview-title" className="text-base font-bold text-gray-900" data-id="element-1609" data-mp="2z9qc4uoy479c">
              Skills Overview
            </h2>
            <p className="mt-0.5 text-xs text-gray-500" data-id="element-1610" data-mp="2uc8fa2o7dihp">
              Review available capacity before assigning skills or pathways to learners.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 md:justify-end" data-id="element-1611" data-mp="30o1i1eb505dw">
          <span className="inline-flex items-center gap-1.5 rounded-md bg-[#FAF5FF] px-2.5 py-1 text-xs font-medium text-[#7E22CE]" data-id="element-1612" data-mp="2mpbcdaa94xdx">
            <MapIcon size={13} aria-hidden="true" data-id="element-1613" data-mp="2qu172vt6c5x9" />
            <strong data-id="element-1614" data-mp="2d09t9b8etzvq">2</strong> Pathways <span className="text-[#A855F7]" data-id="element-1615" data-mp="2cyyszle6ba9d">· 10/40 used - 30 left</span>
          </span>
          <span className="inline-flex items-center gap-1.5 rounded-md bg-[#EAF4F7] px-2.5 py-1 text-xs font-medium text-[#236B8C]" data-id="element-1616" data-mp="2hs1mjtiyajpk">
            <BookOpenIcon size={13} aria-hidden="true" data-id="element-1617" data-mp="230apdrmxqxp7" />
            <strong data-id="element-1618" data-mp="282i3amrbsnu6">4</strong> Skill Modules <span className="text-[#5593B1]" data-id="element-1619" data-mp="27zdsh6jcutuj">· 170/240 used - 70 left</span>
          </span>
        </div>
      </header>

      <div className="max-h-[19rem] overflow-y-auto px-4 py-4 sm:px-5" data-id="element-1620" data-mp="1z0sdfld3dwyi">
        <div className="mb-3 flex items-center justify-between gap-4" data-id="element-1621" data-mp="1yzz20736uja1">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.06em] text-gray-500" data-id="element-1622" data-mp="1fg1omgutmo87">Skills Pathways</h3>
          <p className="hidden text-[11px] text-gray-400 sm:block" data-id="element-1623" data-mp="1ahgjq44mjgdf">Select a pathway to view its skill modules</p>
        </div>
        <div className="space-y-1.5" data-id="element-1624" data-mp="1odbwrtccdx8w">
          {pathways.map(pathway => {
          const isExpanded = expandedPathway === pathway.name;
          const panelId = `pathway-${pathway.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
          return <div key={pathway.name} className="overflow-hidden rounded-lg border border-[#F3E8FF] bg-[#FAF5FF]" data-id="element-1625" data-mp="1tdyktc5d4smc">
                <button type="button" onClick={() => setExpandedPathway(isExpanded ? '' : pathway.name)} aria-expanded={isExpanded} aria-controls={panelId} className={`flex w-full items-center gap-2 px-3 py-2 text-left transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#A855F7] ${isExpanded ? 'bg-[#F3E8FF]' : 'hover:bg-[#F8F0FF]'}`} data-id="element-1626" data-mp="282uo6vwh5hgm">
                  <ChevronDownIcon size={16} aria-hidden="true" className={`flex-none text-[#A855F7] transition-transform ${isExpanded ? 'rotate-180' : ''}`} data-id="element-1627" data-mp="fe4x9h2m7qma" />
                  <span className="min-w-0 flex-1" data-id="element-1628" data-mp="o7grvtgf1uxx">
                    <span className="text-sm font-semibold text-[#581C87]" data-id="element-1629" data-mp="o6yqkiewcqj5">{pathway.name}</span>
                    <span className="ml-3 text-[11px] text-[#A855F7]" data-id="element-1630" data-mp="3nnwwza32c7rm">{pathway.modules.length} modules</span>
                  </span>
                  <span className="whitespace-nowrap text-xs font-medium text-[#A855F7]" data-id="element-1631" data-mp="3snjdbse6u44n">
                    ({pathway.used}/{pathway.total} · {pathway.total - pathway.used} left)
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-1632" data-mp="1bxknbdjgaodu">
                  {isExpanded && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.18
              }} className="overflow-hidden border-t border-[#F3E8FF] bg-white" data-id="element-1633" data-mp="1gvvv7iq6qotf">
                      <div className="p-3 sm:px-7" data-id="element-1634" data-mp="1d8xtm9peocsa">
                        <p className="mb-2 text-[10px] font-semibold uppercase tracking-[0.05em] text-gray-500" data-id="element-1635" data-mp="1d8fm2gxamc52">Included skill modules</p>
                        <div className="flex flex-wrap gap-1.5" data-id="element-1636" data-mp="13arqxpvrz2md">
                          {pathway.modules.map(module => <span key={module} className="rounded bg-[#EAF4F7] px-2 py-1 text-xs font-medium text-[#236B8C]" data-id="element-1637" data-mp="ycgh3f5hcs45">
                              {module}
                            </span>)}
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <h3 className="mb-2 mt-4 text-[11px] font-semibold uppercase tracking-[0.06em] text-gray-500" data-id="element-1638" data-mp="lzmes8a8mpmr">Skill Modules</h3>
        <div className="flex flex-wrap gap-1.5" data-id="element-1639" data-mp="qtqpn2mmjht4">
          {skillModules.map(module => <span key={module.name} className="inline-flex items-center gap-1 rounded bg-[#EAF4F7] px-2 py-1 text-xs font-medium text-[#236B8C]" data-id="element-1640" data-mp="cyelk4mkwezj">
              <span data-id="element-1641" data-mp="14rf9q88vakx4">{module.name}</span>
              <span className="text-[#5593B1]" data-id="element-1642" data-mp="14sgl6dtsp9fd">
                ({module.used}/{module.total} used · <span className={module.total - module.used === 0 ? 'font-semibold text-[#DB3725]' : ''} data-id="element-1643" data-mp="19q8d37ufwvjk">{module.total - module.used} left</span>)
              </span>
            </span>)}
        </div>
      </div>
    </motion.section>;
}